import {BaseRequest} from "./Request";
import {apiRoute} from "../utils";
import FileDownload from "js-file-download";
import moment from "moment";
import { EXPORT_USER_TYPE } from "../constants";


const queryString = require('query-string');

export const exportKycUserList = async () => {
  const baseRequest = new BaseRequest();
  let url = apiRoute(`/users/download?type=${EXPORT_USER_TYPE.KYC_USER_LIST}`);
  const fileData = (await baseRequest.postDownload(url, {})) as any;
  FileDownload(
    fileData,
    `launchpad_users_${moment().format("DD_MM_YYYY")}.csv`
  );
};

export const getKycUserList = async (queryParams: any) => {
  const baseRequest = new BaseRequest();
  let url = apiRoute(`/kyc-users`);
  url += '?' + queryString.stringify(queryParams);

  const response = await baseRequest.get(url) as any;
  const resObject = await response.json();

  return resObject;
};

export const getKycUserDetail = async (id: number | string) => {
  const baseRequest = new BaseRequest();
  let url = apiRoute(`/kyc-users/${id}`);

  const response = await baseRequest.get(url) as any;
  const resObject = await response.json();

  return resObject;
};

export const updateKycUser = async (id: number | string, data: any) => {
  const baseRequest = new BaseRequest();
  let url = apiRoute(`/kyc-users/${id}`);
  const response = await baseRequest.put(url, data) as any;
  const resObject = await response.json();

  return resObject;
};

export const createKycUser = async (data: any) => {
  const baseRequest = new BaseRequest();
  let url = apiRoute(`/kyc-users`);

  const response = await baseRequest.post(url, data) as any;
  const resObject = await response.json();

  return resObject;
};

export const deleteKYCUser = async (userId: any) => {
  const baseRequest = new BaseRequest();
  let url = apiRoute(`/kyc-users/${userId}`);

  const response = await baseRequest.delete(url, {}) as any;
  const resObject = await response.json();

  return resObject;
}

export const changeIsKycStatus = async (data: any) => {
  const baseRequest = new BaseRequest();
  let url = apiRoute(`/kyc-users/${data.userId}/change-kyc`);

  const response = await baseRequest.put(url, {
    is_kyc: data.isKyc,
  }) as any;

  const resObject = await response.json();
  return resObject;
};
